module.exports = __webpack_public_path__ + "img/light.1c051a9c.svg";